import { render, staticRenderFns } from "./KmPage.vue?vue&type=template&id=4fcad4ce&scoped=true&"
import script from "./KmPage.vue?vue&type=script&lang=js&"
export * from "./KmPage.vue?vue&type=script&lang=js&"
import style0 from "./KmPage.vue?vue&type=style&index=0&id=4fcad4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcad4ce",
  null
  
)

export default component.exports